
export function downloadPDF(data, filename){
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
}

export function downloadCSV(data, filename) {
    if (Array.isArray(data)) {
        downloadCSVFile(data, filename);
    } else if (typeof data === 'object' && data !== null) {
        Object.keys(data).forEach((key) => {
            const value = data[key];
            if (Array.isArray(value)) {
                downloadCSVFile(value, `${filename}_${key}`);
            } else {
                console.warn(`Value for key ${key} is not a list, skipping.`);
            }
        });
    } else {
        console.error('Unsupported data type. Expected list or dictionary.');
    }
}

function downloadCSVFile(data, filename) {
    const csvData = csvmaker(data);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}

const csvmaker = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
        return '';
    }
    const headers = Object.keys(data[0]);
    const rows = data.map(row => 
        headers.map(header => `"${row[header] || ''}"`).join(',')
    );
    return [headers.join(','), ...rows].join('\n');
};

export function downloadTXT(data, filename) {
    const textData = typeof data === 'string'? data : JSON.stringify(data);
    const blob = new Blob([textData], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(link.href);
}
